import { useState } from "react";
import { motion } from "framer-motion";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const TermsUpdated = () => {
  const [openSection, setOpenSection] = useState<{
    [key: string]: boolean;
  }>({
    "regulatory-1": false,
    "regulatory-2": false,
    "privacy-1": false,
    "referral-1": false
  });
  const toggleSection = (section: string) => {
    setOpenSection(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };
  return <section id="terms" className="bg-garage-dark py-20">
      <div className="container mx-auto">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="section-title mb-12 pb-4 text-left">Warunki świadczenia usług</motion.h2>
        
        <div className="max-w-4xl mx-auto space-y-8">
          {/* Regulamin usług */}
          <motion.div className="bg-black rounded-lg shadow-lg border border-white/20 overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }}>
            <div className="p-6">
              <h3 className="text-2xl font-semibold mb-6 text-white text-center">REGULAMIN ŚWIADCZENIA USŁUG</h3>
              
              
              <Accordion type="single" collapsible className="w-full space-y-4">
                <AccordionItem value="section-1" className="border-none bg-black rounded-lg border border-white/20">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">
                    §1. POSTANOWIENIA OGÓLNE
                  </AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300 space-y-2">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li className="text-left">Regulamin określa zasady świadczenia usług związanych z detailingiem samochodowym i praniem tapicerki samochodowej.</li>
                      <li className="text-left">Usługa realizowana jest w miejscu i terminie ustalonym indywidualnie z klientem.</li>
                      <li className="text-left">Korzystając z usługi, klient akceptuje niniejszy regulamin.</li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="section-2" className="border-none bg-black rounded-lg border border-white/20">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-base text-left">§2. ZAKRES USŁUGI</AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300 space-y-2">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li className="text-left">Usługa (w zależności od wyboru), może obejmować: kompleksowe czyszczenie i pielęgnację pojazdu, elementów plastikowych, szyb i nadwozia, mycie samochodu zewnątrz, czyszczenie elementów tapicerki materiałowej lub welurowej przy użyciu metody ekstrakcyjnej a także czyszczenia tapicerki skórzanej,.</li>
                      <li className="text-left">Zakres prac każdorazowo określany jest przed przystąpieniem do realizacji zlecenia.</li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="section-3" className="border-none bg-black rounded-lg border border-white/20">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">
                    §3. WARUNKI TECHNICZNE I PRZYGOTOWANIE POJAZDU
                  </AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li>Klient zobowiązany jest do wcześniejszego usunięcia z pojazdu rzeczy osobistych oraz przedmiotów luzem (tyczy się prania ekstrakcyjnego).</li>
                      <li>Klient jest zobowiązany poinformować wykonawcę o:
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                          <li>wcześniejszych naprawach tapicerki,</li>
                          <li>obecności niestandardowych materiałów,</li>
                          <li>ukrytych uszkodzeniach lub problemach z wnętrzem, bądź zewnętrznymi elementami auta.</li>
                        </ul>
                      </li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="section-4" className="border-none bg-black rounded-lg border border-white/20">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">
                    §4. CZAS REALIZACJI I SCHNIĘCIE
                  </AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li>Standardowy czas wykonania usługi (w zależności od wyboru usługi) wynosi od 1 do 8 godzin.</li>
                      <li>Czas realizacji może ulec zmianie w zależności od:
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                          <li>stopnia i rodzaju zabrudzeń,</li>
                          <li>wielkości pojazdu,</li>
                          <li>warunków atmosferycznych.</li>
                        </ul>
                      </li>
                      <li>Tapicerka po zakończeniu usługi może pozostać wilgotna – orientacyjny czas schnięcia wynosi od 6 do 24 godzin i zależy od temperatury otoczenia, wentylacji oraz wilgotności powietrza.</li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="section-5" className="border-none bg-black rounded-lg border border-white/20">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">§5. ODPOWIEDZIALNOŚĆ</AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li>Wykonawca dokłada wszelkich starań, aby usługa została wykonana z należytą starannością, przy użyciu bezpiecznych, profesjonalnych środków czystości.</li>
                      <li>Wykonawca nie ponosi odpowiedzialności za:
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                          <li>utrwalone plamy, które nie dają się usunąć mimo zastosowania odpowiednich środków,</li>
                          <li>ukryte wady materiału, plastików lub elementów karoserii,</li>
                          <li>pogłębienie istniejących uszkodzeń niewidocznych przed rozpoczęciem usługi.</li>
                        </ul>
                      </li>
                      <li>Ewentualne reklamacje przyjmowane są w ciągu 48 godzin od zakończenia usługi.</li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="section-6" className="border-none bg-black rounded-lg border border-white/20">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-base text-left">
                    §6. PŁATNOŚĆ I REZERWACJA
                  </AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li>Płatność następuje bezpośrednio po wykonaniu usługi – gotówką lub przelewem (inne formy płatności – po wcześniejszym uzgodnieniu).</li>
                      <li>Zmiana terminu lub odwołanie wizyty możliwe jest nie później niż 24 godziny przed umówionym terminem.</li>
                      <li>W przypadku nieobecności klienta w umówionym czasiemoże zostać naliczona opłata za dojazd zgodna z cennikiem oraz dochodzenia kary umownej w wysokości 49 zł za zablokowanie terminu i niewykonanie usługi.</li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </motion.div>

          {/* Polityka Prywatności */}
          <motion.div className="bg-black rounded-lg shadow-lg border border-white/20 overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }}>
            <div className="p-6">
              <h3 id="privacy-policy" className="text-2xl font-semibold mb-6 text-white text-center">POLITYKA PRYWATNOŚCI</h3>
              
              <Accordion type="single" collapsible className="w-full space-y-4">
                <AccordionItem value="privacy-1" className="border-none bg-black rounded-lg border border-white/20">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">§1. INFORMACJE OGÓLNE</AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300 space-y-2">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li>Niniejsza Polityka Prywatności określa zasady przetwarzania danych osobowych przez 061 Garage Detailing Studio – firmie z siedzibą w Poznaniu, świadczącej usługi mycia pojazdów zewnątrz, detailingu wnętrz, 
prania tapicerki samochodowej, meblowej, materacy oraz dywanów.</li>
                      <li>Administratorem danych osobowych jest 061GarageDetailingStudio (dalej: „Administrator"), e-mail kontaktowy: 061garageds@gmail.com</li>
                      <li>Administrator dokłada wszelkich starań, aby dane osobowe były przetwarzane zgodnie z obowiązującymi przepisami prawa, w szczególności z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 („RODO").</li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="privacy-2" className="border-none bg-black rounded-lg border border-white/20">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">§2. ZAKRES I CEL PRZETWARZANIA DANYCH</AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li>Dane osobowe klientów mogą być przetwarzane w następujących celach:
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                          <li>realizacja usług świadczonych przez Administratora,</li>
                          <li>kontakt organizacyjny (potwierdzenie wizyt, przypomnienia, pytania),</li>
                          <li>wystawianie rachunków i prowadzenie rozliczeń,</li>
                          <li>obsługa reklamacji,</li>
                          <li>uczestnictwo w Programie Poleceń,</li>
                          <li>cel marketingowy (tylko za zgodą osoby, której dane dotyczą).</li>
                        </ul>
                      </li>
                      <li>Przetwarzane dane obejmują m.in.: imię, nazwisko, numer telefonu, adres e-mail, adres wykonania usługi oraz – w razie potrzeby – dane do rozliczeń.</li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="privacy-3" className="border-none bg-black rounded-lg border border-white/20">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">§3. PODSTAWY PRAWNE PRZETWARZANIA</AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300">
                    <p className="mb-2">Dane osobowe przetwarzane są na podstawie:</p>
                    <ul className="list-disc pl-5 space-y-2">
                      <li>art. 6 ust. 1 lit. b RODO – w celu wykonania umowy lub podjęcia działań przed jej zawarciem,</li>
                      <li>art. 6 ust. 1 lit. a RODO – na podstawie zgody osoby, której dane dotyczą,</li>
                      <li>art. 6 ust. 1 lit. f RODO – na podstawie prawnie uzasadnionego interesu Administratora.</li>
                    </ul>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="privacy-4" className="border-none bg-black rounded-lg border border-white/20">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">§4. UDOSTĘPNIANIE DANYCH</AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li>Dane osobowe nie są przekazywane osobom trzecim bez wyraźnej zgody, chyba że wymagają tego obowiązujące przepisy prawa.</li>
                      <li>W szczególnych przypadkach dane mogą być przekazane podmiotom wspierającym Administratora w realizacji usług (np. hosting, księgowość, operatorzy płatności), na podstawie stosownych umów powierzenia przetwarzania danych.</li>
                      <li>Dane nie są przekazywane poza Europejski Obszar Gospodarczy (EOG).</li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="privacy-5" className="border-none bg-black rounded-lg border border-white/20">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">§5. CZAS PRZECHOWYWANIA DANYCH</AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li>Dane osobowe przechowywane są przez okres niezbędny do realizacji celu, dla którego zostały zebrane.</li>
                      <li>Po zakończeniu świadczenia usług dane są przechowywane:
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                          <li>przez czas wymagany przepisami podatkowymi i rachunkowymi,</li>
                          <li>do czasu przedawnienia ewentualnych roszczeń,</li>
                          <li>do momentu wycofania zgody – w przypadku danych przetwarzanych na jej podstawie.</li>
                        </ul>
                      </li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="privacy-6" className="border-none bg-black rounded-lg border border-white/20">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">
                    §6. PRAWA OSOBY, KTÓREJ DANE DOTYCZĄ
                  </AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300">
                    <p className="mb-2">Każda osoba, której dane są przetwarzane, ma prawo do:</p>
                    <ul className="list-disc pl-5 space-y-1">
                      <li>dostępu do swoich danych i otrzymania ich kopii,</li>
                      <li>sprostowania lub uzupełnienia danych,</li>
                      <li>usunięcia danych (prawo do bycia zapomnianym),</li>
                      <li>ograniczenia przetwarzania,</li>
                      <li>przenoszenia danych do innego administratora,</li>
                      <li>wniesienia sprzeciwu wobec przetwarzania danych,</li>
                      <li>wycofania zgody w dowolnym momencie,</li>
                      <li>wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (PUODO), jeśli uzna, że przetwarzanie narusza przepisy RODO.</li>
                    </ul>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </motion.div>

          {/* Program Poleceń */}
          <motion.div className="bg-garage-gray/20 rounded-lg shadow-lg border border-gray-700 overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }}>
            <div className="p-6">
              <h3 id="referral-program" className="text-2xl font-semibold mb-6 text-white text-center">PROGRAM POLECEŃ</h3>
              
              <Accordion type="single" collapsible className="w-full space-y-4">
                <AccordionItem value="referral-1" className="border-none bg-garage-gray/20 rounded-lg">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">
                    §1. POSTANOWIENIA OGÓLNE
                  </AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300 space-y-2">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li className="text-left">Organizatorem programu poleceń jest 061 Garage Detailing Studio, firma z siedzibą w Poznaniu.</li>
                      <li className="text-left">Program ma na celu promowanie usług Organizatora tj. mycie samochodów zewnątrz, detailing wnętrz, 
pranie tapicerki samochodowej, meblowej oraz dywanów.</li>
                      <li className="text-left">Uczestnikiem programu może być każda osoba fizyczna, która skorzystała z usług organizatora oraz zaakceptowała niniejszy regulamin.</li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="referral-2" className="border-none bg-garage-gray/20 rounded-lg">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">
                    §2. ZASADY DZIAŁANIA PROGRAMU
                  </AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li>Każdy Uczestnik Programu może polecać usługi Organizatora innym osobom (dalej: „Polecony").</li>
                      <li>W momencie rezerwacji terminu, Polecony zobowiązany jest podać imię i nazwisko osoby polecającej.</li>
                      <li>Polecenie uznaje się za skuteczne, jeśli spełnione są wszystkie poniższe warunki:
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                          <li>Polecony jest nowym klientem (nie korzystał wcześniej z usług Organizatora),</li>
                          <li>Usługa została w pełni wykonana i opłacona.</li>
                        </ul>
                      </li>
                      <li>Za każde skuteczne polecenie Uczestnik otrzymuje wynagrodzenie w wysokości 10% wartości brutto zrealizowanej usługi przez Poleconego.</li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="referral-3" className="border-none bg-garage-gray/20 rounded-lg">
                  <AccordionTrigger className="px-4 py-3 text-white hover:text-garage-blue hover:no-underline text-left">
                    §3. FORMA ROZLICZENIA
                  </AccordionTrigger>
                  <AccordionContent className="px-4 pb-4 text-gray-300">
                    <ol className="list-decimal pl-5 space-y-2">
                      <li>Wynagrodzenie za skuteczne polecenie może zostać przekazane:
                        <ul className="list-disc pl-5 mt-2">
                          <li>w formie rabatowej zniżki na kolejną usługę.</li>
                        </ul>
                      </li>
                      <li>Jeżeli wymagają tego przepisy prawa, może zostać zawarta stosowna umowa cywilnoprawna (np. umowa zlecenie).</li>
                      <li>Rabat przyznany z tytułu polecenia nie łączy się z innymi promocjami lub ofertami specjalnymi, chyba że Organizator zdecyduje inaczej.</li>
                    </ol>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default TermsUpdated;